// Dialog component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import IconButton from '../../common/icon_button/icon_button.jsx'

class Dialog extends Component {
  static get propTypes () {
    return {
      title: PropTypes.string,
      active: PropTypes.bool,
      modal: PropTypes.bool,
      hasScroll: PropTypes.bool,
      children: PropTypes.node,
      type: PropTypes.oneOf(['normal', 'medium', 'large', 'video', 'confirm']),
      animationType: PropTypes.oneOf(['normal', 'fast']),
      onClose: PropTypes.func,
      canCloseOnEsc: PropTypes.bool,
      className: PropTypes.string
    }
  }

  static get defaultProps () {
    return {
      title: '',
      active: false,
      modal: false,
      hasScroll: true,
      children: '',
      type: 'normal',
      animationType: 'normal',
      canCloseOnEsc: true,
      onClose: null,
      className: ''
    }
  }

  componentDidMount () {
    document.body.addEventListener('keydown', this._handleDocumentKeyDown)
  }

  componentWillUnmount () {
    document.body.removeEventListener('keydown', this._handleDocumentKeyDown)
  }

  /* Event handlers */
  _handleDocumentKeyDown = (evt) => {
    const keyCode = evt.keyCode

    if (keyCode === 27 && this.props.active && this.props.canCloseOnEsc) {
      this.onClose()
    }
  };

  render () {
    const {
      active,
      children,
      title,
      type,
      modal,
      hasScroll,
      animationType,
      className
    } = this.props

    const _className = classnames(
      [
        'dialog',
        [`dialog_${type}`],
        [`dialog_animate${animationType}`],
        [className]
      ],
      {
        dialog_active: active,
        dialog_noscroll: !hasScroll
      }
    )
    return (
      <div className={_className}>
        <div className='overlay' />
        <div className='content'>
          {modal ? (
            <IconButton
              icon='popup-close'
              className='modal'
              canHover
              onClick={this._onClickClose.bind(this)}
            />
          ) : null}
          {title ? <h6 className='title'>{title}</h6> : null}
          {children}
        </div>
      </div>
    )
  }

  /* Public Functions */
  onClose () {
    this.setState({ active: false })

    if (this.props.onClose) {
      this.props.onClose()
    }
  }

  /* Event handlers */
  _onOverlayClick (ev) {
    ev.preventDefault()

    this.onClose()
  }

  _onClickClose (ev) {
    ev.preventDefault()

    this.onClose()
  }
}

export default Dialog
